import Vue from 'vue';
import Router from 'vue-router';
import { defaultRouter } from './defaultRouter.js';
import utils from '../utils/util.js';
import base64 from '../utils/base64.js';

Vue.use(Router);
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
}
const routes = [
    {
        path: '/',
        redirect: '/homePage',
    },
    {
        path: '/home',
        name: "home",
        component: () => import('../components/pages/home/home.vue'),
        children: [
            {
                path: '/homePage',
                name: "homePage",
                component: () => import('../components/pages/homePage/homePage.vue'),
                meta: {
                    name: '主页',
                },
            },
            {
                path: '/search',
                name: "search",
                component: () => import('../components/pages/search/search.vue'),
                meta: {
                    name: '搜索页',
                },
            },
            {
                path: '/problemDetails',
                name: "problemDetails",
                component: () => import('../components/pages/problemDetails/problemDetails.vue'),
                meta: {
                    name: '问题详情',
                },
            },
            {
                path: '/problemfeedback',
                name: "problemfeedback",
                component: () => import('../components/pages/problemfeedback/problemfeedback.vue'),
                meta: {
                    name: '问题反馈',
                },
            },
            {
                path: '/serviceRecord',
                name: "serviceRecord",
                // component: () => import('../components/pages/serviceRecord/serviceRecord.vue'),
                meta: {
                    name: '服务记录',
                },
            },
        ]
    },
    ...defaultRouter,
];
export const router = new Router({
    // mode:'history',
    routes,
});
router.beforeEach((to, from, next) => {
    const href = window.location.href;
    if(href.indexOf('?')!=-1){
        let param = utils.getQueryBase64ParamsToJson();
        Vue.prototype.$sessionStorage.setStore('params',JSON.stringify(param));
    };
    next();
});


// WEBPACK FOOTER //
// ./src/router/index.js